export default __webpack_public_path__ + "static/step-two-cb08a05447bd13deb9e32a497f19a4c7.png";